// 이벤트 관리 관련 타입 정의

// 노출 상태 타입
export type ExposureType = 'show' | 'hide';
export type ExposureDisplayType = '노출' | '비노출';

// 이벤트 아이템 인터페이스
export interface EventItem {
  id: number;
  layoutName: string;
  exposureType: ExposureType;
  startDate?: string | null;
  endDate?: string | null;
  mediaName: string;
  content?: string;
  videoFile?: string;
  videoUrl?: string; // GCS 또는 로컬 저장소의 실제 비디오 URL
  fileSize?: number; // 파일 크기 (bytes)
  createdAt: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
}

// 이벤트 목록 응답 인터페이스
export interface EventListResponse {
  data: EventItem[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

// 이벤트 생성 요청 인터페이스
export interface CreateEventRequest {
  layoutName: string;
  exposureType: ExposureType;
  startDate?: string | null;
  endDate?: string | null;
  mediaName: string;
  content?: string;
  videoFile: File;
}

// 이벤트 수정 요청 인터페이스
export interface UpdateEventRequest extends Partial<CreateEventRequest> {
  id: number;
  deleteCurrentFile?: boolean; // 기존 파일 삭제 여부
}

// 이벤트 필터 옵션
export interface EventFilterOptions {
  exposureType?: ExposureType | 'all';
  searchKeyword?: string;
  page?: number;
  limit?: number;
}

// 이벤트 관리 유틸리티 함수
export const getExposureDisplayText = (exposureType: ExposureType): ExposureDisplayType => {
  return exposureType === 'show' ? '노출' : '비노출';
};

export const getExposureTypeFromDisplay = (displayType: ExposureDisplayType): ExposureType => {
  return displayType === '노출' ? 'show' : 'hide';
};
